export default "__VITE_ASSET__CwHIlF4l__"